import { TableConfig } from '@shared/interfaces/table/table-config';
import { MeteringPointChargeInformationDto } from '@app/api/dmc';
import { validFromPartialTable } from '@shared/partials/validfrom-partial.table';
import { validToPartialTable } from '@shared/partials/validto-partial.table';
import { datahubPartial } from '@shared/partials/datahub.partial';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import {LinkCellComponent} from '@shared/components/table/cells/link-cell/link-cell.component';

export const MeteringPointPricingTable: TableConfig<MeteringPointChargeInformationDto> = {
  selectable: true,
  selectableType: 'single',
  columns: [
    {
      title: 'meteringpoint.pricing.chargetype',
      key: 'chargeType',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        notspecified: 'enum.chargetype.notspecified',
        subscription: 'enum.chargetype.subscription',
        fee: 'enum.chargetype.fee',
        tariff: 'enum.chargetype.tariff',
      }
    },
    {
      title: 'meteringpoint.pricing.chargetypeid',
      key: 'chargeTypeId',
    },
    validFromPartialTable,
    validToPartialTable,
    {
      title: 'meteringpoint.pricing.owner',
      key: 'chargeInformationOwner',
    },
    {
      title: 'meteringpoint.pricing.taxindicator',
      key: 'taxIndicator',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        'true': 'common.yes',
        'false': 'common.no',
      }
    },
    {
      title: 'meteringpoint.pricing.transparentinvoicing',
      key: "transparentInvoicing",
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        'true': 'common.yes',
        'false': 'common.no',
      }
    },
    {
      title: 'meteringpoint.pricing.chargeoccurrence',
      key: 'chargeOccurrences',
    },
    datahubPartial,
    {
      title: 'meteringpoint.pricing.statusreasoncode',
      key: 'statusReasonCode',
    },
    {
      title: 'meteringpoint.pricing.unknownstatus',
      key: 'unknownStatus',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        'true': 'common.yes',
        'false': 'common.no',
      }
    }
  ],
};
